<template>
  <ProjectOverView id="top">
    <template #new-project-dialog>
      <DialogNewProject
        style="position: fixed"
        v-if="get_dialog_new_project_show"/>
    </template>
    <template #action_bar>
      <RadioButtonTextGroup
        :id="`project-overview-radio-button-text`"
        :elements="[
          { text: 'All', value: 'all', },
          { text: 'MULTI.projects', value: 'multi', },
          { text: 'Projects', value: 'projects', },
        ]"
        :selected="project_show_toggle"
        @buttonClicked="project_show_toggle=$event"
      />

      <div
        class="projectsoverview-action-bar-right-side"
        :style="$vuetify.breakpoint.smAndDown ? 'flex-direction: column;' : 'flex-direction: row;'"
      >
        <div class="projectsoverview-action-bar-right-side-terminated">
          <TText v-if="hasBusiness" value="Show Company Projects Only" />
          <ToggleCapsule
          v-if="hasBusiness"
          :is_active="$store.state.View['is_project_overview_show_company_only']"
          knob_color="white"
          foreground_color="green"
          @toggleClicked="toggleShowCompanyOnly()"
          />
          <TText value="Show Terminated Projects" />
          <ToggleCapsule
            :is_active="$store.state.View['is_project_overview_show_terminated']"
            knob_color="white"
            foreground_color="green"
            @toggleClicked="toggleShowTerminated()"
          />
        </div>
        <DropDown
          :items="sort_options.map(item => item.name)"
          :value="project_overview_sort.name"
          :translatable="true"
          max_width="200"
          @selected="updateOverviewSorting($event)"
        />
        <SearchBar
          max_width="200"
          :is_live_emit="true"
          underscored
          @search="updateOverviewFilter($event), scrollUp()"
        />
      </div>
    </template>
    <template v-if="!loading" #projects>
        <router-view height="100%"/>
        <ProjectCard v-for="project in getProjectOverview(project_show_toggle).sort(sortFn)"
          :key="project.type + project.id"
          :image="project.image ? project.image : ''"
          :header="project.name"
          height="300px"
          :type="project.type"
          content_height="200px"
          :checkbox="false"
          :info_row="true"
          :loading="project.id === project_id_loading?true:false"
          :project_information="project.type === 'projects' ? project.information : getMultiProjectInformation(project.id)"
          @clickAll="project.type === 'projects' ? routeToProject(project.id, project.information.trains_count, false) : routeToMultiProject(project.type, project.id)"
        >
          <template #content>
            <div v-if="project.type === 'multiprojects'" style="display: flex; flex-direction: row; gap: 5px; padding: 5px">
              <ProjectCard v-for="sub_project in getMultiProjectSubProjects(project.id)"
                :key="sub_project.type + sub_project.id"
                :width="`calc((${1/columns} * (100vw - 20px) / ${getMultiProjectSubProjectsCount(project.id).project_count + (getMultiProjectSubProjectsCount(project.id).additional_count > 0 ? 1 : 0)}) - (5px + 5px / ${getMultiProjectSubProjectsCount(project.id).project_count + (getMultiProjectSubProjectsCount(project.id).additional_count > 0 ? 1 : 0)})`"
                :image="sub_project.image"
                :header="sub_project.name"
                content_height="140px"
                :checkbox="false"
                />
                <div v-if="getMultiProjectSubProjectsCount(project.id).additional_count > 0"
                  :style="`
                  width: calc((${1/columns} * (100vw - 20px) / ${getMultiProjectSubProjectsCount(project.id).project_count + (getMultiProjectSubProjectsCount(project.id).additional_count > 0 ? 1 : 0)}) - (5px + 5px / ${getMultiProjectSubProjectsCount(project.id).project_count + (getMultiProjectSubProjectsCount(project.id).additional_count > 0 ? 1 : 0)});
                  font-size: 40px;
                  display: flex;
                  justify-content: center;
                  align-items: center
                  `"
                  >
                  + {{getMultiProjectSubProjectsCount(project.id).additional_count}}
                </div>
            </div>
          </template>
          <template #body>
            <div class="projectsoverview-info-flex">
              <div class="projectsoverview-info-left">
                <div v-if="project.type === 'multiprojects'" class="projectsoverview-info-buttons">
                  <ButtonOutlined
                    v-if="!$store.getters['View/isMobile']"
                    icon="empty-paper"
                    value="Manage"
                    padding="0 16px"
                    @buttonClicked="routeToMultiProject(project.type, project.id)"
                  />
                  <!-- NOTE: this button is needed so click.prevent.stop can trigger -->
                  <button
                    @click.prevent.stop="$router.push({name: 'MultiProjectSchedule', params: {multiproject_id: project.id}})"
                  >
                    <!-- NOTE: this is for visuals only! -->
                    <ButtonOutlined
                      icon="calendar"
                      value="Schedule"
                      padding="0 16px"
                    />
                  </button>
                </div>

                <div v-else-if="project.type === 'projects'">
                  <TTooltip value="PROJECT.role">
                    <div class="projectsoverview-prole">
                      <TIcon
                        name="person-small"
                      />
                      <div>{{project.prole}}</div>
                    </div>
                  </TTooltip>
                  <div class="projectsoverview-info-flex" style="grid-gap: 3px;">
                    <TTooltip v-for="(tooltip, i) in tooltips"  :key="i" :value="tooltip.text">
                        <button
                          style="border: 1px solid white; border-radius: 4px;"
                          @click.stop="
                            project_id_loading = project.id;
                            tooltip.route == 'ProjectWallet'?
                              routeToProject(project.id, project.information.trains_count, true)
                            :
                              $router.push({
                                  name: tooltip.route,
                                  params: {project_id: project.id}
                                })
                          "
                        >
                        <TIcon
                          :name="tooltip.icon"
                        />
                        </button>
                    </TTooltip>
                  </div>
                </div>
              </div>
              <div class="projectsoverview-info-center">
                <div v-if="project.type === 'projects'" class="projectsoverview-info-flex">
                  <WorkPackage
                    v-for="(work_package, index) in project.work_packages"
                    style="flex-shrink: 0;"
                    :key="index"
                    :color="`${work_package.color} ${work_package.color.includes('lighten') || work_package.color.includes('darken')? '':'lighten-1'}`"
                    :token="work_package.token"
                    :icon="work_package.icon"
                    :zoom="1"
                    >
                    <template #workpackage>
                      <StandardBadge
                        color="white"
                        :text="work_package.count"
                        content_color="black"
                        :zoom="0.9"
                      />
                    </template>
                  </WorkPackage>
                </div>
              </div>
              <div class="projectsoverview-info-right">
                <template v-if="isCompanyProject(project) & project.type === 'projects'">
                  <TTooltip class="projectsoverview-info-company" value="COMPANY.project" >
                    <TIcon name="company"/>
                  </TTooltip>
                </template>
                <template v-else>
                  <v-spacer></v-spacer>
                </template>
                <div
                  class="projectsoverview-info-status"
                  v-if="project.type === 'projects'"
                >
                  <TIcon
                    :name="$store.state.Ultra.project_states.find(function(state) { return state.value === project.status}).icon"
                  />
                  <TText
                    style="align-self: center;"
                    :value="project.status"
                    font_weight="400"
                  />
                </div>
              </div>
            </div>
          </template>
          <!-- NOTE: buttons slot is not needed, because the design here goes from left to right instead of top to bottom -->
          <!-- <template #buttons>
          </template> -->
        </ProjectCard>
    </template>
  </ProjectOverView>
</template>
<script>
import { ProjectOverviewMixin } from '@/mixins/ProjectOverview.mixin.js'

import DialogNewProject from '@/components/ProjectOverView/DialogNewProject.component.vue'
import ProjectOverView from '@/components/ProjectOverView/ProjectOverView.component.vue'
import TText from '@/components/Taktify/TText.component.vue'
import TIcon from '@/components/Taktify/TIcon.component.vue'
import RadioButtonTextGroup from '@/components/WorkPackageWIP/RadioButtonTextGroup.component.vue'
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue'
// import TSearchField from '@/components/Taktify/TSearchField.component.vue'
import SearchBar from '@/components/WorkPackageWIP/SearchBar.component.vue'
import DropDown from '@/components/WorkPackageWIP/DropDown.component.vue'
import ToggleCapsule from '@/components/WorkPackageWIP/ToggleCapsule.component.vue'
// import StandardCard from '@/components/StandardComponents/StandardCard.component.vue'
// import ProjectInfo from '@/components/ProjectOverView/ProjectInfo.component.vue'

import store from '@/store/index'
import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue'
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
// import StandardDropdown from '@/components/StandardComponents/StandardDropdown.component.vue'

// import ProjectWidget from '@/components/ProjectOverView/ProjectWidget.component.vue'
import ProjectCard from '@/components/ProjectOverView/ProjectCard.component.vue'

import {
  mapActions,
  mapGetters
} from 'vuex';
export default {
  name: 'App',
  components: {
    DialogNewProject,
    ProjectOverView,
    WorkPackage,
    StandardBadge,
    ProjectCard,
    TText,
    TIcon,
    RadioButtonTextGroup,
    ButtonOutlined,
    // TSearchField,
    SearchBar,
    DropDown,
    ToggleCapsule,
    // StandardDropdown
  },
  mixins: [
    ProjectOverviewMixin,
  ],
  data: () => ({
    project_id_loading: -1,
    loading: true,
    tserachupdatekey: 0,
    search: '',
    project_show_toggle: 'all',
    tooltips: [
      {text: 'TAKT.wallet', route: 'ProjectWallet', icon: 'wallet'},
      {text: 'TAKT.journal', route: 'ProjectTaktJournal', icon: 'journal'},
      {text: 'PROJECT.structure', route: 'ProjectStructure', icon: 'project-structure'},
      {text: 'PROJECT.settings', route: 'ProjectSettings', icon: 'gear-small'}
    ],
    sort_options: [
      {value: 'created_asc', name: 'Created date (asc)'},
      {value: 'created_desc', name: 'Created date (desc)'},
      {value: 'status_asc', name: 'Project status (asc)'},
      {value: 'status_desc', name: 'Project status (desc)'},
      {value: 'name_asc', name: 'Name alphabetical (a-z)'},
      {value: 'name_desc', name: 'Name alphabetical (z-a)'}
    ],
    project_overview_sort: {
      value: 'status_asc',
      name: 'Project status (asc)'
    },
    sortFn: undefined
  }),
  created() {
    let sort_fun = localStorage.getItem('TAKT_projectsoverview_sort') || 'status_asc';
    // Hacky fix: should not be requried after a while...
    if (sort_fun === 'undefined' || sort_fun === '[object Object]') {
      sort_fun = 'status_asc';
    }
    this.selectSortFunction(sort_fun);
    this.project_overview_sort = this.sort_options.find( item => item.value === sort_fun);
    this.cancelOverviewFilter();
    let promisses = [];
    // TODO: load terminated projects
    // let load_terminated = localStorage.getItem('Project_Overview_Show_Terminated');
    promisses.push(
      store.dispatch('Ultra/requestUObject', {
        url: [
          {projects: ''},
          {showWithEntitiesNormalized: ''}
        ],
        url_suffix: this.hasPermission('Project LIMITLESS') ? '&limit=500' : ''
      })
    );

    promisses.push(
      store.dispatch('Ultra/requestUObject', {
        url: [
          {multiprojects: ''},
          {showWithEntitiesNormalized: ''}
        ]
      })
    );

    Promise.all(promisses).then(() => {
      this.loading = false;
      this.setLoadingProjectOverview(false);
      this.setPosition();
    }
    );
  },
  watch: {
    project_overview_sort: {
      handler(newVal){
        if (newVal.value) {
          this.selectSortFunction(newVal.value);
        } else {
          this.selectSortFunction(newVal);
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('Project', [
      'getProjectOverview',
      'getMultiProjectInformation',
      'getMultiProjectSubProjects',
      'getMultiProjectSubProjectsCount'
    ]),
    ...mapGetters('ProjectCalendar', [
      'getCurrentTaktIndex',
    ]),
    ...mapGetters('View', [
      'get_dialog_new_project_show'
    ]),
    ...mapGetters('Auth', [
      'hasBusiness',
      'hasPermission',
      'getUser'
    ]),
    columns(){
      if (this.$vuetify.breakpoint.smAndDown) {
        return 1;
      } else if(this.$vuetify.breakpoint.mdOnly) {
        return 2;
      } else {
        return 3;
      }
    },
    count(){
      return 3;
    }
  },
  methods: {
    scrollUp() {
      setTimeout(function () {
        document.getElementById('top').scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
        },200);
    },
    test(evt) {
      console.log(evt);
    },
    isCompanyProject(project) {
      if (this.getUser.business && this.getUser.business.projects) {
        return this.getUser.business.projects.includes(project.id)
      }
      return false
    },
    cancelOverviewFilter(){
      this.search = '';
      this.tserachupdatekey++;
      this.updateOverviewFilter('');
    },
    routeToMultiProject(project_type, project_id) {
      this.$router.push({
        name: 'MultiProjectDetailsDialog',
        params: {
          multiproject_id: project_id
        }
      })
    },
    selectSortFunction(newVal){
      localStorage.setItem('TAKT_projectsoverview_sort', newVal);
      switch (newVal) {
        case 'created_asc':
          this.sortFn = this.createdAscSort;
          break;
        case 'created_desc':
          this.sortFn = this.createdDescSort;
          break;
        case 'status_asc':
          this.sortFn = this.statusAscSort;
          break;
        case 'status_desc':
          this.sortFn = this.statusDescSort;
          break;
        case 'name_asc':
          this.sortFn = this.nameAscSort;
          break;
        case 'name_desc':
          this.sortFn = this.nameDescSort;
          break;
        default:
          this.sortFn = this.createdAscSort;
      }
    },
    toggleShowTerminated() {
      let storeKey = 'is_project_overview_show_terminated';
      let localStorageKey = 'Project_Overview_Show_Terminated';
      localStorage.setItem(localStorageKey, !this.$store.state.View[storeKey]);
      this.setValue({ key: storeKey, value: !this.$store.state.View[storeKey] });
    },
    toggleShowCompanyOnly() {
      let storeKey = 'is_project_overview_show_company_only';
      let localStorageKey = 'Project_Overview_Show_Company_Only';
      localStorage.setItem(localStorageKey, !this.$store.state.View[storeKey]);
      this.setValue({ key: storeKey, value: !this.$store.state.View[storeKey] });
    },
    createdAscSort(a,b) {
      if (a.id < b.id) {
        return -1;
      }
      if (a.id > b.id) {
        return 1;
      }
      return 0;
    },
    createdDescSort(a,b) {
      if (a.id > b.id) {
        return -1;
      }
      if (a.id < b.id) {
        return 1;
      }
      return 0;
    },
    statusAscSort(a,b) {
      return a.status.localeCompare(b.status);
    },
    statusDescSort(a,b) {
      return b.status.localeCompare(a.status);
    },
    nameAscSort(a,b) {
      return a.name.localeCompare(b.name);
    },
    nameDescSort(a,b) {
      return b.name.localeCompare(a.name);
    },
    updateOverviewSorting(sort_by) {
      let option = this.sort_options.filter(elem => { return elem.name === sort_by })[0];
      this.project_overview_sort = option;
    },
    test2(id) {
      let index = this.checked.indexOf(id)
      if(index === -1) {
        this.checked.push(id)
      } else {
        this.checked.remove(index);
      }
    },
    ...mapActions('Project', [
      'requestProjectOverView',
      'updateOverviewFilter',
    ]),
    ...mapActions('View', [
      'setLoadingProjectOverview',
      'setValue',
    ]),

    // ...mapActions('Ultra', [
    //   'requestUObject'
    // ]),
    routeToProject(project_id, trains_count, route_to_wallet) {
      this.project_id_loading = project_id;
      // if (this.$vuetify.breakpoint.smAndDown) {
      if (store.getters['View/isMobile'] || route_to_wallet) {
        store.dispatch('Ultra/requestUObject', {
          url: [
            {projects: project_id},
            {'showWithEntitiesNormalized': ''}
          ]
        }).then(() => {
            let promises = [
              store.dispatch('Project/requestProjectPermissions', {
                project_id: project_id
              }),
              store.dispatch('Message/requestMessagesProjectActive', {
                project_id: project_id
              }),
              store.dispatch('Project/requestProjectInformation', {
                project_id: project_id
              }),
            ];
            Promise.all(promises)
            .then(() => {
              this.$router.push({
                name: 'ProjectWallet',
                params: {
                  project_id: project_id,
                  takt_index: this.getCurrentTaktIndex(project_id) !== false?
                  Math.abs(this.getCurrentTaktIndex(project_id)):1
                }
              });
            });
        });
      } else {
        if (trains_count > 0) {
          this.$router.push({name: 'Project', params: {project_id: project_id}});
        } else {
          this.$router.push({name: 'AddTrain',
          params: {
            project_id: project_id,
            train_index: 0,
            direction: 0
          }});
        }
      }
    },
    getCols(){
      if (this.$vuetify.breakpoint.smAndDown) {
        return 12;
      } else if(this.$vuetify.breakpoint.mdOnly) {
        return 6;
      } else {
        return 4;
      }
    }
  }
};
</script>
<style>
  .projectsoverview-prole {
    display: flex;
    align-items: center;
  }
  .projectsoverview-action-bar-right-side {
    display: flex;
    grid-gap: 16px;
    align-items: center;
    padding: 8px 16px 8px 16px;
  }
  .projectsoverview-action-bar-right-side-terminated {
    display: flex;
    grid-gap: 8px;
    padding-right: 4px;
  }
  .projectsoverview-info-left, .projectsoverview-info-right {
    margin: 4px 6px;
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
  }
  .projectsoverview-info-center {
    flex-grow: 1;
    display: flex;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    margin: 4px 4px;
  }
  .projectsoverview-info-status {
    height: 24px;
    align-self: flex-end;
    display: flex;
    align-items: center;
  }
  .projectsoverview-info-company {
    height: 24px;
    align-self: flex-end;
    display: flex;
    align-items: center;
    margin-top: 7.5px;
  }
  .projectsoverview-info-flex, .projectsoverview-info-buttons {
      display: flex;
      justify-content: flex-start;
      width: 100%;
  }
  .projectsoverview-info-buttons {
      grid-gap: 6px;
  }
</style>
